import { writable } from 'svelte/store';

export const authenticated = writable(0);
export const accessToken = writable(0);

export const setValue = function(variableName,value){
	 eval(variableName).set(value);
	 window.localStorage.setItem(variableName,value)
}
